import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, withCtx as _withCtx } from "vue"

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_Icon = _resolveComponent("Icon")
  const _component_Button = _resolveComponent("Button")

  return (_openBlock(), _createBlock(_component_Button, {
    plain: "",
    class: _normalizeClass(["ai-option", {[$props.type]: true, 'active': $props.selected}])
  }, {
    default: _withCtx(() => [
      ($options.icon)
        ? (_openBlock(), _createBlock(_component_Icon, {
            key: 0,
            icon: $options.icon,
            stroke: $options.icon_color,
            height: "2rem",
            width: "2rem"
          }, null, 8 /* PROPS */, ["icon", "stroke"]))
        : _createCommentVNode("v-if", true),
      _createTextVNode(" " + _toDisplayString(_ctx.$utils.str.capitalize($props.title)), 1 /* TEXT */)
    ]),
    _: 1 /* STABLE */
  }, 8 /* PROPS */, ["class"]))
}